import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="footer-container">
        <div className="footer-items">
          <div className="footer-links">
            <div className="column">
              <h4 className="footer-h4">Policies</h4>
              <ul>
                <li>
                  <Link to="/privacy"> Privacy Policy </Link>
                </li>
                <li>
                  <Link to="/terms"> Terms & Conditions </Link>
                </li>
                <li>
                  <Link to="/shipping"> Shipping & Returns </Link>
                </li>
              </ul>
            </div>
            <div className="column">
              <h4 className="footer-h4"> Useful Links </h4>
              <ul>
                <li>
                  <Link to="/contact"> Contact Us </Link>
                </li>
                <li>
                  <Link to="/about"> About Us</Link>
                </li>
                <li>
                  <Link to="/login"> Login </Link>
                </li>
              </ul>
            </div>
            <div className="column">
              <h4 className="footer-h4"> Contact Info </h4>
              <ul>
                <li>Email: Info@rubiajewels.in</li>
                <li>Mobile No: +91 9925383602</li>
                <li>
                  Address : 14, 1ST FLOOR, TAPOVAN ESTATE,, B/H. JIVANDHARA
                  HOTEL, VARACHHA ROAD,, SURAT, SURAT, GUJARAT, 395006
                </li>
              </ul>
            </div>
            <div className="column">
              <h4 className="footer-h4"> Social </h4>
              <div className="social-icons">
                <i className="icon">
                  <i class="fa-brands fa-instagram"></i>
                </i>
                <i className="icon">
                  <i class="fa-brands fa-facebook"></i>
                </i>
                <i className="icon">
                  <i class="fa-brands fa-linkedin"></i>
                </i>
                <i className="icon">
                  <i class="fa-brands fa-twitter"></i>
                </i>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p> © Rubia Jewels 2017 - 2025 </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
